import { WifiOff } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNetworkStatus } from "@/hooks/useNetworkStatus";

export function OfflineBanner() {
  const isOnline = useNetworkStatus();
  const { t } = useTranslation();

  if (isOnline) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-50 flex items-center justify-center gap-2 bg-amber-600 text-white px-4 py-2 text-sm font-medium shadow-lg">
      <WifiOff className="h-4 w-4 shrink-0" />
      <span>{t("offline.message")}</span>
    </div>
  );
}
